<template>
  <v-facebook-login @login="login"
                    @logout="logout"
                    @sdk-init="handleSdkInit"
                    :version="graphVersion"
                    :login-options="{scope: 'whatsapp_business_management,whatsapp_business_messaging,business_management,publish_video,ads_management,instagram_basic,instagram_content_publish,pages_show_list,pages_read_engagement,pages_manage_posts'}"
                    :app-id="appId"></v-facebook-login>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import VFacebookLogin from 'vue-facebook-login-component'
import axios from "axios";

export default {
  name: 'FacebookLogin',
  props: ['index', 'platform'],
  components: {VFacebookLogin},
  mounted() {
    this.$forceUpdate();
  },
  data() {
    return {
      appId: "363011885466127",
      graphVersion: window.Laravel.facebookGraphVersion,
      FB: {}
    }
  }, methods: {
    ...mapMutations([
      'getChannelCredentials'
    ]),
    login(e) {
      if (e?.authResponse.accessToken) {
        axios.post('/backend/client_api_credentials', {
          platform: 'facebook',
          credentials: {
            id: this.credentials.id,
            client_id: this.record.client_id,
            facebook_token: e.authResponse.accessToken,
            facebook_token_expire_date: e.authResponse.data_access_expiration_time
          }
        }).then(() => {
          this.getChannelCredentials()
        })
      }
    },
    logout() {
      axios.delete(`/backend/client_api_credentials/${this.credentials.id}`, {
        client_id: this.record.client_id,
      }).then(() => {
        this.getChannelCredentials()
      })
    },
    handleSdkInit({FB, scope}) {
      if (this.credentials.facebook_token_expire_date * 1000 < Date.now()) {
        this.logout();
        FB.logout();
      }
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'getIsAdmin',
      channels: 'getChannels',
      record: 'getRecord',
      credentials: 'getChannelCredentials'
    })
  }
}
</script>

<style scoped>
</style>
